<template>
  <div class="content-wrapper">
    <TheStoreHeader page="1" :is0yen-ticket="is0yenTicket" />

    <div class="form">
      <h1 class="title">決済方法を選択してください</h1>
      <PaymentMethodSelect />

      <div class="description" v-html="newlineConvert(description)" />
      <div class="foot-button-block">
        <div class="actions">
          <div class="button-container">
            <ItemButton
              label="次へ"
              action-type="btn-primary"
              @clicked="createBookGroup"
            />

            <ItemButton
              :label="$t('common.cancelButtonLabel')"
              action-type="btn-cancel"
              @clicked="cancel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" :timeout-seconds="7000" />
  <!-- 販売制限エラーダイアログ -->
  <DialogSaleLimit ref="DialogSaleLimit" :message="saleLimitErrorMessage" />
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import API from "@/API";
import userInfoService from "@/services/userInfo";
import commonService from "@/services/common";
import moment from "@/services/moment";
import bookGroupService from "@/services/bookGroup";
import { buildSurveyRoute } from "@/services/survey";

export default {
  name: "TemplateBookBookingPaymentSelection",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    const divisionCalTotalPrice = computed(() =>
      bookGroupService.calTotal(bookGroup.value)
    );
    const is0yenTicket = computed(() => {
      if (bookGroup.value == null) return false;
      else return divisionCalTotalPrice.value == 0;
    });
    //input
    const inputDivisions = store.getters["input/ticketing/storeDivisions"];
    const inputStartDateOfUse =
      store.getters["input/ticketing/storeStartDateOfUse"];
    const inputStoreSelectedStationCode =
      store.getters["input/ticketing/storeSelectedStationCode"];
    const inputPaymentMethod = computed(
      () => store.getters["input/ticketing/storePaymentMethod"]
    );

    console.log("inputDivisions::", inputDivisions);
    console.log("inputStartDateOfUse::", inputStartDateOfUse);
    console.log("storeSelectedStationCode::", inputStoreSelectedStationCode);

    const isSubscription = computed(() =>
      commonService.checkIsSubscription(route.params.id)
    );

    //description from masterBook.description_json.xxx
    const description =
      masterBook.value.content.description_json.MbBeforeSettlementCaution;

    // dialogs
    const DialogLoading = ref(null);
    const DialogSaleLimit = ref(null);
    const saleLimitErrorMessage = ref("");

    // チケット内容を確認するボタンをおして発火する関数
    const createBookGroup = async () => {
      try {
        if (!is0yenTicket.value) {
          //check need to reCreate BookGroup
          let isReCreateBookGroup = false;

          //exist book_group is direct refund && select in-direct refund payment method
          if (
            (book.value.refundable == null || book.value.refundable == true) &&
            checkIsInDirectRefundPayment()
          ) {
            isReCreateBookGroup = true;
          }
          //exist book_group is in-direct refund && select direct refund payment method
          else if (
            book.value.refundable == false &&
            !checkIsInDirectRefundPayment()
          ) {
            isReCreateBookGroup = true;
          }

          //re-create book_group
          if (isReCreateBookGroup) {
            console.log("re-create book_group !!!");
            DialogLoading.value.openDialog();
            //remove exist book_group
            try {
              await API.cancelBookGroup(bookGroup.value.id);
            } catch (err) {
              console.log("ERROR::cancelBookGroup");
            }

            //create new book_group with (refundable = false)
            await postCreateBookGroup();

            DialogLoading.value.closeDialog();
          }
        }

        if (bookGroup.value?.master_survey_id > 0) {
          router.push(buildSurveyRoute(bookGroup.value, masterBook.value));
          return;
        }
        gotoBookBookingConfirmation();
      } catch (err) {
        console.log("Error in createBookGroup :", err);

        DialogLoading.value.closeDialog();

        // 販売制限に関するエラーの場合は、ダイアログ表示
        if (err.response.data.error == "reserved_error") {
          saleLimitErrorMessage.value =
            "この券種・日程は完売したか、販売対象日になっていません。";
          DialogSaleLimit.value.openDialog();
        } else if (err.response.data.error == "sales_error_end_of_sale") {
          saleLimitErrorMessage.value =
            "このチケットの販売期間は終了しました。";
          DialogSaleLimit.value.openDialog();
        } else if (
          err.response.data.error == "sales_error_reservation_expired"
        ) {
          saleLimitErrorMessage.value =
            "仮予約から所定の時間が経過したため、仮予約が取り消されました。もう一度お試しください。";
          DialogSaleLimit.value.openDialog();
        } else if (err.response.data.error == "sales_error_suspended") {
          saleLimitErrorMessage.value =
            "このチケットは現在お取り扱いを中止しております。";
          DialogSaleLimit.value.openDialog();
        }
      }
    };

    // Goto confirmation page
    const gotoBookBookingConfirmation = () => {
      router.push({
        name: "BookBookingConfirmation",
        params: {
          id: route.params.id,
          book_group_id: store.getters["ticketing/bookGroup"].id,
        },
        query: {
          language: store.getters["common/lang"],
          is_0yen_ticket: is0yenTicket.value,
          master_book_set_id: route.query.master_book_set_id,
        },
      });
    };

    // リクエストボディを作成
    const makeApiParams = () => {
      // リクエスト用のapiParamsをObjectで初期化
      var apiParams = {};

      // POST /createBookGroup でリクエストに載せるuser_idをidTokenから抽出する
      var userId = userInfoService.getUserIdFromIdToken();

      // POST /createBookGroup でリクエストに載せるunitを整える
      var unit = arrangeUnit();

      // POST /createBookGroup でリクエストに載せるstartDayを整える
      var startDay = arrangeStartDay();

      // POST /createBookGroup のリクエストボディを作成
      apiParams = {
        master_book_id: masterBook.value.id,
        user_id: userId,
        started_at: startDay,
        // 以下8つの枠をAPI parametersとして整形するが、division==null の時は無になるのでOK
        unit: unit,
      };

      //in-direct refund
      if (checkIsInDirectRefundPayment()) {
        //store in bookgroup
        apiParams.refundable = false;
      }
      return apiParams;
    };

    const checkIsInDirectRefundPayment = () => {
      //in-direct: refundable_count >= 2 (alipay+)
      if (
        !is0yenTicket.value &&
        !(
          inputPaymentMethod.value.refundable_count != null &&
          inputPaymentMethod.value.refundable_count >= 2
        )
      ) {
        return true;
      }
    };

    //リクエストに載せるunitを整える
    const arrangeUnit = () => {
      // POST /createBookGroup で囲繞するunitを整える
      var unit = [];
      // Emotパスポートはcount: 1 のみ
      if (isSubscription.value) {
        console.log("subscription !!!");
        unit = [{ count: Number(inputDivisions[0].count) }];
      } else {
        inputDivisions.map((d) =>
          unit.push({
            division: d.dataName,
            count: Number(d.count),
            from_station_code: inputStoreSelectedStationCode,
          })
        );
      }
      return unit;
    };

    //リクエストに載せるstartDayを整える
    const arrangeStartDay = () => {
      // is_readyがfalseの場合、日付指定せず、null
      var startDay = null;
      if (masterBook.value.is_ready) {
        startDay = moment(new Date(inputStartDateOfUse)).format();
      }
      return startDay;
    };

    // bookGroup作成APIコール
    const postCreateBookGroup = async () => {
      // リクエストボディを作成
      var apiParams = makeApiParams();

      // bookGroup作成
      await API.createBookGroup(apiParams);
    };
    const cancel = async () => {
      DialogLoading.value.openDialog();

      try {
        await API.cancelBookGroup(bookGroup.value.id);
      } catch (err) {
        console.log("ERROR::cancelBookGroup");
      }

      //goto bookBooking
      router.go(-1);
    };

    return {
      is0yenTicket,
      description,
      createBookGroup,
      cancel,
      DialogLoading,
      DialogSaleLimit,
      saleLimitErrorMessage,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin: 15px 0 22px 0 !important;
  font-size: 18px;
  font-weight: bold;
}
.form {
  width: 90%;
  margin: 20px auto;
}
.description {
  padding-top: 15px;
  font-size: 15px;
  line-height: 24px;
  padding-bottom: 140px;
}

.foot-button-block {
  position: fixed;
  z-index: 99;
  width: 100%;
  bottom: 0;
  background-color: #fff;
}

.foot-button-block .actions {
  width: 90%;
  margin: auto;
}
</style>
